(function(){
  'use strict';

  function ready(fn){
    if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, {once:true});
    else fn();
  }

  ready(function(){
    var cfg = document.getElementById('cfg-sales-boost');
    if(!cfg) return;

    var variants = [];
    try {
      var json = cfg.querySelector('[data-cfg-variants]');
      variants = JSON.parse(json ? json.textContent : '[]');
    } catch(e) {}

    var productId = String(cfg.getAttribute('data-product-id') || '');
    var currentHandle = String(cfg.getAttribute('data-product-handle') || '');
    var floating = document.querySelector('[data-cfg-floating-buy]');
    var floatingTrigger = document.querySelector('[data-cfg-floating-trigger]');
    var floatingPrice = document.querySelector('[data-cfg-floating-price]');
    var exitModal = document.querySelector('[data-cfg-exit-modal]');
    var exitCode = cfg.getAttribute('data-exit-code') || 'WELCOME3';
    var exitSeenKey = 'cfg_exit_offer_' + (productId || 'product');
    var primaryButton = null;
    var insertAttempts = 0;
    var upsellLoading = false;

    function visible(el){
      if(!el) return false;
      var style = window.getComputedStyle(el);
      if(style.display === 'none' || style.visibility === 'hidden') return false;
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    }

    function findPrimaryButton(){
      if(primaryButton && document.documentElement.contains(primaryButton) && visible(primaryButton) && !primaryButton.disabled) return primaryButton;
      var selectors = [
        '.shopify-payment-button__button:not([disabled])',
        'button[data-testid="Checkout-button"]:not([disabled])',
        '.product-form__submit:not([disabled])',
        '.so-btn-add-to-cart:not([disabled])',
        'button.so-form-btn-cta-main:not([disabled])'
      ];
      for(var i=0;i<selectors.length;i++){
        var nodes = document.querySelectorAll(selectors[i]);
        for(var j=0;j<nodes.length;j++){
          if(visible(nodes[j])){ primaryButton = nodes[j]; return primaryButton; }
        }
      }
      return null;
    }

    function getCartForm(){
      var btn = findPrimaryButton();
      if(btn && btn.form) return btn.form;
      if(btn){
        var form = btn.closest('form[action*="/cart/add"]');
        if(form) return form;
      }
      return document.querySelector('form[action*="/cart/add"]');
    }

    function getVariantId(){
      var form = getCartForm();
      var idInput = form && form.querySelector('[name="id"]');
      if(idInput && idInput.value) return String(idInput.value);
      var shine = document.getElementById('current_variant_id');
      if(shine && shine.value) return String(shine.value);
      return String(cfg.getAttribute('data-selected-variant') || '');
    }

    function currentVariant(){
      var id = getVariantId();
      for(var i=0;i<variants.length;i++) if(String(variants[i].id) === id) return variants[i];
      return variants[0] || null;
    }

    function formatCents(cents){
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      try { return new Intl.NumberFormat(undefined,{style:'currency',currency:currency}).format(Number(cents || 0)/100); }
      catch(e) { return '$' + (Number(cents || 0)/100).toFixed(2); }
    }

    function updatePrice(){
      var v = currentVariant();
      if(v && floatingPrice) floatingPrice.textContent = v.formatted_price || formatCents(v.price);
    }

    function findPurchaseAnchor(){
      var btn = findPrimaryButton();
      if(!btn) return null;
      var pay = btn.closest('.shopify-payment-button');
      if(pay) return pay;
      var buttons = btn.closest('.product-form__buttons, .so-btn-add-to-cart-wrap, .product-form--sticky-wrapper');
      if(buttons) return buttons;
      return btn;
    }

    /* ---------------- Lightweight offer timer ---------------- */
    function insertTimer(){
      if(document.querySelector('[data-cfg-offer-timer]')) return true;
      var anchor = findPurchaseAnchor();
      if(!anchor || !anchor.parentNode) return false;
      var timer = document.createElement('div');
      timer.className = 'cfg-offer-timer';
      timer.setAttribute('data-cfg-offer-timer','');
      timer.innerHTML = '<span class="cfg-offer-timer__icon" aria-hidden="true">◷</span><div><strong>3% gift offer</strong><span>Use <b>'+escapeHtml(exitCode)+'</b> in the next</span></div><time data-cfg-timer-value>15:00</time>';
      anchor.insertAdjacentElement('beforebegin', timer);

      var key = 'cfg_offer_deadline_' + (productId || 'product');
      var now = Date.now();
      var deadline = 0;
      try { deadline = Number(sessionStorage.getItem(key) || 0); } catch(e) {}
      if(!deadline || deadline <= now){
        deadline = now + (15 * 60 * 1000);
        try { sessionStorage.setItem(key, String(deadline)); } catch(e) {}
      }
      var value = timer.querySelector('[data-cfg-timer-value]');
      function tick(){
        var left = Math.max(0, deadline - Date.now());
        var total = Math.ceil(left / 1000);
        var m = Math.floor(total / 60);
        var s = total % 60;
        if(value) value.textContent = String(m).padStart(2,'0') + ':' + String(s).padStart(2,'0');
        if(left <= 0){
          timer.classList.add('is-ended');
          timer.querySelector('strong').textContent = 'Gift offer window ended';
          var detail = timer.querySelector('div span');
          if(detail) detail.textContent = 'Continue shopping — your cart is still available.';
          return;
        }
        window.setTimeout(tick, 1000);
      }
      tick();
      return true;
    }

    function imageUrl(product){
      var image = product && product.featured_image;
      if(image && typeof image === 'object') image = image.url || image.src;
      if(!image && product && product.images && product.images.length){
        image = typeof product.images[0] === 'string' ? product.images[0] : (product.images[0].src || product.images[0].url);
      }
      if(!image) return '';
      if(image.indexOf('//') === 0) image = 'https:' + image;
      return image;
    }

    function firstAvailableVariant(product){
      var list = product && product.variants ? product.variants : [];
      for(var i=0;i<list.length;i++) if(list[i].available !== false) return list[i];
      return list[0] || null;
    }

    function productPriceCents(product, variant){
      var raw = variant && variant.price != null ? variant.price : product.price;
      if(typeof raw === 'string'){
        if(raw.indexOf('.') !== -1) return Math.round(parseFloat(raw) * 100);
        raw = Number(raw);
      }
      raw = Number(raw || 0);
      return raw < 1000 && raw % 1 !== 0 ? Math.round(raw * 100) : raw;
    }

    function escapeHtml(value){
      return String(value == null ? '' : value).replace(/[&<>'"]/g,function(ch){
        return {'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[ch];
      });
    }

    function recommendationsUrl(intent){
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      return root + 'recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=6&intent=' + intent;
    }

    function fetchRecommendations(intent){
      return fetch(recommendationsUrl(intent), {credentials:'same-origin', headers:{'Accept':'application/json'}})
        .then(function(r){ if(!r.ok) throw new Error('Recommendations unavailable'); return r.json(); })
        .then(function(data){ return data && data.products ? data.products : []; });
    }

    function getRecommendations(){
      return fetchRecommendations('complementary').then(function(products){
        if(products && products.length) return products;
        return fetchRecommendations('related');
      }).catch(function(){
        return fetchRecommendations('related').catch(function(){ return []; });
      }).then(function(products){
        var out = [];
        for(var i=0;i<products.length && out.length<3;i++){
          var p = products[i];
          if(!p || String(p.handle || '') === currentHandle) continue;
          if(!firstAvailableVariant(p)) continue;
          out.push(p);
        }
        return out;
      });
    }

    function renderGiftCard(product, index){
      var variant = firstAvailableVariant(product);
      if(!variant) return '';
      var img = imageUrl(product);
      var price = productPriceCents(product, variant);
      var href = product.url || ('/products/' + encodeURIComponent(product.handle || ''));
      return ''+
        '<label class="cfg-gift-set__item" data-cfg-gift-card data-variant-id="'+escapeHtml(variant.id)+'" data-price="'+escapeHtml(price)+'">'+
          '<input type="checkbox" class="cfg-gift-set__check" data-cfg-gift-check '+(index===0?'checked':'')+' aria-label="Add '+escapeHtml(product.title)+' to gift set">'+
          '<span class="cfg-gift-set__tick" aria-hidden="true">✓</span>'+
          '<a class="cfg-gift-set__image" href="'+escapeHtml(href)+'" tabindex="-1">'+
            (img ? '<img src="'+escapeHtml(img)+'" alt="'+escapeHtml(product.title)+'" loading="lazy" width="180" height="180">' : '<span class="cfg-gift-set__placeholder">Gift</span>')+
          '</a>'+
          '<span class="cfg-gift-set__info"><span class="cfg-gift-set__kicker">ADD TO GIFT</span><a href="'+escapeHtml(href)+'" class="cfg-gift-set__title">'+escapeHtml(product.title)+'</a><strong>'+escapeHtml(formatCents(price))+'</strong></span>'+
        '</label>';
    }

    function announceCartRefresh(){
      try { document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true})); } catch(e) {}
      try { document.dispatchEvent(new CustomEvent('cart:updated', {bubbles:true})); } catch(e) {}
      try { window.dispatchEvent(new CustomEvent('cart:refresh')); } catch(e) {}
    }

    function selectedCards(wrap){
      return Array.prototype.slice.call(wrap.querySelectorAll('[data-cfg-gift-card]')).filter(function(card){
        var cb = card.querySelector('[data-cfg-gift-check]');
        return cb && cb.checked;
      });
    }

    function updateGiftTotal(wrap){
      var cards = selectedCards(wrap);
      var total = 0;
      for(var i=0;i<cards.length;i++) total += Number(cards[i].getAttribute('data-price') || 0);
      var count = wrap.querySelector('[data-cfg-gift-count]');
      var price = wrap.querySelector('[data-cfg-gift-total]');
      var button = wrap.querySelector('[data-cfg-add-selected]');
      if(count) count.textContent = cards.length + (cards.length === 1 ? ' gift selected' : ' gifts selected');
      if(price) price.textContent = cards.length ? formatCents(total) : '—';
      if(button){
        button.disabled = !cards.length;
        button.querySelector('span').textContent = cards.length ? 'Add Selected Gifts' : 'Select a Gift';
      }
    }

    function addSelectedGifts(wrap){
      var cards = selectedCards(wrap);
      var button = wrap.querySelector('[data-cfg-add-selected]');
      if(!cards.length || !button || button.disabled) return;
      var items = cards.map(function(card){ return {id:Number(card.getAttribute('data-variant-id')), quantity:1}; });
      button.disabled = true;
      var label = button.querySelector('span');
      if(label) label.textContent = 'Adding gifts…';
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method:'POST', credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:items})
      }).then(function(r){ if(!r.ok) throw new Error('Add failed'); return r.json(); })
        .then(function(){
          if(label) label.textContent = 'Gifts Added ✓';
          button.classList.add('is-added');
          announceCartRefresh();
          window.setTimeout(function(){ button.disabled=false; button.classList.remove('is-added'); updateGiftTotal(wrap); }, 1800);
        }).catch(function(){
          if(label) label.textContent = 'Try Again';
          window.setTimeout(function(){ button.disabled=false; updateGiftTotal(wrap); }, 1500);
        });
    }

    function insertGiftUpsell(){
      if(document.querySelector('[data-cfg-gift-upsell]')) return true;
      var anchor = findPurchaseAnchor();
      if(!anchor || !anchor.parentNode) return false;

      var wrap = document.createElement('section');
      wrap.className = 'cfg-gift-set';
      wrap.setAttribute('data-cfg-gift-upsell','');
      wrap.setAttribute('aria-label','Build a gift set');
      wrap.innerHTML = ''+
        '<div class="cfg-gift-set__head"><div><span class="cfg-gift-set__eyebrow">MAKE IT A COMPLETE GIFT</span><h3>Build Their Gift Set</h3><p>Choose another gift to add with this one.</p></div><span class="cfg-gift-set__pill">Optional add-on</span></div>'+
        '<div class="cfg-gift-set__loading" data-cfg-gift-loading><span></span><span></span><span></span></div>'+
        '<div class="cfg-gift-set__grid" data-cfg-gift-grid hidden></div>'+
        '<div class="cfg-gift-set__footer" data-cfg-gift-footer hidden><div><small data-cfg-gift-count>1 gift selected</small><strong data-cfg-gift-total>—</strong></div><button type="button" data-cfg-add-selected><span>Add Selected Gifts</span><b>+</b></button></div>';

      anchor.insertAdjacentElement('afterend', wrap);
      if(upsellLoading) return true;
      upsellLoading = true;

      getRecommendations().then(function(products){
        var loading = wrap.querySelector('[data-cfg-gift-loading]');
        var grid = wrap.querySelector('[data-cfg-gift-grid]');
        var footer = wrap.querySelector('[data-cfg-gift-footer]');
        if(loading) loading.remove();
        if(!products.length){ wrap.remove(); return; }
        var html = '';
        for(var i=0;i<products.length;i++) html += renderGiftCard(products[i], i);
        grid.innerHTML = html;
        grid.hidden = false;
        footer.hidden = false;
        grid.addEventListener('change', function(e){ if(e.target.matches('[data-cfg-gift-check]')) updateGiftTotal(wrap); });
        var add = wrap.querySelector('[data-cfg-add-selected]');
        if(add) add.addEventListener('click', function(){ addSelectedGifts(wrap); });
        updateGiftTotal(wrap);
      }).catch(function(){ wrap.remove(); });
      return true;
    }

    function scheduleInsert(){
      var timerOk = insertTimer();
      var upsellOk = insertGiftUpsell();
      if(timerOk && upsellOk) return;
      if(insertAttempts++ >= 12) return;
      window.setTimeout(scheduleInsert, 250);
    }

    function setupFloating(){
      var btn = findPrimaryButton();
      if(!floating || !btn) return;
      function setFloating(show){
        floating.classList.toggle('is-visible', !!show);
        floating.setAttribute('aria-hidden', show ? 'false' : 'true');
        if(window.innerWidth < 750) document.body.style.paddingBottom = show ? '76px' : '';
        else document.body.style.paddingBottom = '';
      }
      if('IntersectionObserver' in window){
        var observer = new IntersectionObserver(function(entries){ setFloating(window.scrollY > 160 && !entries[0].isIntersecting); }, {threshold:0.05});
        observer.observe(btn);
      }
    }

    if(floatingTrigger){
      floatingTrigger.addEventListener('click', function(){
        var btn = findPrimaryButton();
        if(!btn) return;
        try { btn.click(); } catch(e) { btn.scrollIntoView({behavior:'smooth',block:'center'}); }
      });
    }

    var exitShown = false;
    function hasSeenExit(){ try { return sessionStorage.getItem(exitSeenKey) === '1'; } catch(e) { return false; } }
    function markExitSeen(){ try { sessionStorage.setItem(exitSeenKey,'1'); } catch(e) {} }
    function openExit(){
      if(!exitModal || exitShown || hasSeenExit()) return;
      exitShown = true; markExitSeen();
      exitModal.classList.add('is-open'); exitModal.setAttribute('aria-hidden','false'); document.body.classList.add('cfg-exit-open');
    }
    function closeExit(){
      if(!exitModal) return;
      exitModal.classList.remove('is-open'); exitModal.setAttribute('aria-hidden','true'); document.body.classList.remove('cfg-exit-open');
    }

    if(exitModal){
      var closers = exitModal.querySelectorAll('[data-cfg-exit-close]');
      for(var c=0;c<closers.length;c++) closers[c].addEventListener('click', closeExit);
      var codeEl = exitModal.querySelector('[data-cfg-exit-code]');
      if(codeEl) codeEl.textContent = exitCode;
      var claim = exitModal.querySelector('[data-cfg-claim-discount]');
      if(claim) claim.href = '/discount/' + encodeURIComponent(exitCode) + '?redirect=' + encodeURIComponent(location.pathname + location.search);
      var copy = exitModal.querySelector('[data-cfg-copy-code]');
      if(copy) copy.addEventListener('click', function(){
        if(navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(exitCode).then(function(){ copy.textContent = 'Copied!'; });
        else copy.textContent = exitCode;
      });
      document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeExit(); });
      if(window.matchMedia('(pointer:fine)').matches) document.documentElement.addEventListener('mouseleave', function(e){ if(e.clientY <= 0) openExit(); }, {passive:true});
    }

    document.addEventListener('change', function(e){
      if(!e.target) return;
      if(e.target.matches('[name="id"]') || e.target.closest('variant-selects, variant-radios, variant-picker')){
        primaryButton = null; window.setTimeout(updatePrice, 50);
      }
    }, {passive:true});
    document.addEventListener('variant:change', function(){ primaryButton = null; window.setTimeout(updatePrice, 50); });

    scheduleInsert();
    updatePrice();
    setupFloating();
  });
})();
